export function getParamsValid() {
  const value = localStorage.getItem("isParamsValid");
  return value ? JSON.parse(value) : null;
}

export function setParamsValid(value) {
  localStorage.setItem("isParamsValid", JSON.stringify(value));
}

export function deleteParamsValid() {
  localStorage.removeItem("isParamsValid");
}
